const locale = navigator.language || navigator.userLanguage;

export const viewmenuData = locale === 'fr-FR' ? [
    { name: "Dashboard", id: "dashboard" },
    { name: "Paramètres", id: "settings" },
    // { name: "Liste des équipements", id: "equipments" },
] :
[
    { name: "Dashboard", id: "dashboard" },
    { name: "Settings", id: "settings" },
    // { name: "Liste des équipements", id: "equipments" },
]

export const indicatorlist =  locale === 'fr-FR' ? [
    { name: "Politiques énergétiques", id: "policies" },
    { name: "Dernières connexions", id: "lastconnexion" },
]  :
[
    { name: "Energy policies", id: "policies" },
    { name: "Last connections", id: "lastconnexion" },
]